import Cookies from "js-cookie";

export const v1TokenCookieName =
  process.env.NEXT_PUBLIC_ACCESS_TOKEN_COOKIE_NAME || "unknown";
export const v2TokenCookieName = "yz_v2_token";

export function isPagePublic(pathname: string): boolean {
  return true;
}

export function v2TokenValue(): string {
  return Cookies.get(v2TokenCookieName) || "";
}
